import { SVGFC } from '@repo/toolkit/types'

const UnlinkIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_34960_974132)">
        <path
          d="M17.13 12.1873L18.42 10.9048H18.405C19.0955 10.1893 19.4738 9.22905 19.4569 8.23488C19.4401 7.24072 19.0294 6.29388 18.315 5.60225C17.6152 4.9274 16.6809 4.55029 15.7087 4.55029C14.7366 4.55029 13.8023 4.9274 13.1025 5.60225L11.8125 6.88475"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.87745 11.8125L5.59495 13.095C4.90448 13.8105 4.52615 14.7707 4.54302 15.7649C4.5599 16.759 4.9706 17.7059 5.68495 18.3975C6.38474 19.0724 7.31902 19.4495 8.2912 19.4495C9.26338 19.4495 10.1977 19.0724 10.8975 18.3975L12.18 17.115"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.5V6.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 9H6.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.25V19.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 15H19.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_34960_974132">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default UnlinkIcon
